import { Component } from '@angular/core';

@Component({
  selector: 'app-applink',
  templateUrl: './applink.component.html',
  styleUrls: ['./applink.component.scss']
})
export class ApplinkComponent {

}
